import client from './client';

export const sessionMonitorApi = {
  // One-shot snapshot of the current user's sessions. The live view uses the
  // SSE stream (/api/session-monitor/stream) directly; this is the fallback
  // used when EventSource is unavailable.
  async list() {
    const { data } = await client.get('/api/session-monitor/sessions');
    return data.sessions || [];
  },
};
